import { render } from "./ModalPopupPage.vue?vue&type=template&id=59472352&scoped=true"
import script from "./ModalPopupPage.vue?vue&type=script&lang=js"
export * from "./ModalPopupPage.vue?vue&type=script&lang=js"

import "./ModalPopupPage.vue?vue&type=style&index=0&id=59472352&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59472352"]])

export default __exports__